import { createFileRoute } from "@tanstack/react-router"

import { pageHead } from "@/lib/metadata"
import { getChangelog } from "@/server/web"
import { ScrollText } from "lucide-react"

import Link from "@/components/link"
import { Button } from "@anysola/ui/button"
import { EmptyState } from "@anysola/ui/empty-state"
import { UnavailableAlert } from "@/components/feedback/unavailable-alert"
import { Container } from "@/components/layout/container"
import { SiteShell } from "@/components/layout/site-shell"
import { ChangelogTimeline } from "@/components/changelog/changelog-timeline"

/** Every published entry, newest first, on a date rail with a tag filter. */
function ChangelogPage() {
  const changelog = Route.useLoaderData()

  return (
    <SiteShell>
      <h1 className="sr-only">Changelog</h1>
      <Container className="pt-12 pb-16 sm:pt-16 sm:pb-24">
        {changelog === null ? (
          <UnavailableAlert title="The changelog is unavailable right now." />
        ) : changelog.length === 0 ? (
          <EmptyState
            icon={<ScrollText />}
            title="No changes published yet"
            className="w-full py-16"
          >
            <Button variant="secondary" render={<Link href="/news" />}>
              Read the news
            </Button>
          </EmptyState>
        ) : (
          <ChangelogTimeline entries={changelog} />
        )}
      </Container>
    </SiteShell>
  )
}

export const Route = createFileRoute("/changelog")({
  // Admin edits revalidate this page; the TTL (300 s, in the service) only
  // bounds a direct database edit.
  loader: () => getChangelog(),
  head: () =>
    pageHead({
      title: "Changelog",
      description: "New features, improvements and fixes across Anysola.",
      path: "/changelog",
      image: "/changelog/opengraph-image",
    }),
  component: ChangelogPage,
})
